import * as React from "react";
import { type IconProps, iconProps } from "../util/IconProps";
export function LanguageIcon(props: IconProps): React.JSX.Element {
  const { color, size, ...rest } = iconProps(props);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      {...rest}
      viewBox="0 0 24 24"
    >
      <path
        fill={color}
        fillRule="evenodd"
        d="M13 3.805V11h3.42C16.205 7.95 15 5.395 13 3.805Zm-2 0V11H7.58C7.795 7.95 9 5.395 11 3.805ZM11 13H7.58C7.795 16.051 9 18.606 11 20.195V13Zm-7.945-2h2.521C5.744 8.3 6.6 5.805 8.123 3.876A9.007 9.007 0 0 0 3.055 11ZM1 12C1 5.933 5.912 1.013 11.977 1a1.02 1.02 0 0 1 .046 0C18.088 1.013 23 5.933 23 12c0 6.068-4.912 10.988-10.977 11a.903.903 0 0 1-.046 0C5.912 22.988 1 18.068 1 12Zm7.123 8.125A9.007 9.007 0 0 1 3.055 13h2.521c.168 2.702 1.023 5.195 2.547 7.125Zm7.754 0A9.007 9.007 0 0 0 20.945 13h-2.521c-.168 2.702-1.023 5.196-2.547 7.125ZM20.945 11a9.007 9.007 0 0 0-5.068-7.124C17.4 5.805 18.256 8.299 18.424 11h2.521ZM13 20.195c2-1.59 3.205-4.144 3.42-7.195H13v7.195Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
